<div class="requested-price-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container requested-price-table-section">
    <article class="requested-price-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Campaign Issued</p>
          <h2>Product Campaigns</h2>
        </div>
        <span class="badge-counter">{{ count || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">Serial No.</th>
              <th scope="col">Image</th>
              <th scope="col">Product Name</th>
              <th scope="col">Unit/Size</th>
              <th scope="col">Price</th>
              <th scope="col">Quantity</th>
              <th scope="col">Start Date & Time</th>
              <th scope="col">End Date & Time</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of campaignList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
              <td>{{ 10 * (currentPage - 1) + i + 1 }}</td>
              <td>
                <img
                  class="imagtag"
                  src="{{ item?.productId?.thumbnail }}"
                  alt=""
                />
              </td>
              <td>{{ item?.productId?.productName }}</td>
              <td>
                {{ item?.campaignDetail[0]?.value }}
                {{
                  item?.campaignDetail[0]?.unit !== "other"
                    ? "" + item?.campaignDetail[0]?.unit
                    : ""
                }}
              </td>
              <td>
                {{
                  item?.campaignDetail[0]?.discountedPrice
                    ? getPrice(
                        item?.campaignDetail[0]?.discountedPrice
                          | currency: "ZAR":"R"
                      )
                    : item?.campaignDetail[0]?.discountedPrice
                }}
              </td>
              <td>{{ item?.campaignDetail[0]?.releaseQuantity }}</td>
              <td>
                {{ item?.createdAt | date: "yyyy-MM-dd h:mm:ss a" || "--" }}
              </td>
              <td>
                {{ item?.endDate | date: "yyyy-MM-dd h:mm:ss a" || "--" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="campaignList?.length === 0 && !isLoading"
        class="empty-state text-center"
      >
        <p class="text-muted mb-3">
          No campaigns found. Once campaigns are created, they will appear here.
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="bi bi-receipt"
          width="58"
          height="58"
          fill="lightgray"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"
          />
          <path
            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>

      <app-table-loader
        *ngIf="isLoading"
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="8"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="requested-price-table-footer" *ngIf="count > 10">
        <pagination-controls (pageChange)="changePageNumber($event)">
        </pagination-controls>
      </div>
    </article>
  </section>
</div>